
import { Link } from "react-router-dom";
import notfound from "../../assets/images/notfound404.jpg";
import "./style/notfound.css"; 

function Notfound(){

  return(
       <> 
       <div className="Not-Found"> 
         <img src={notfound} alt="page not found" style={{ margin:"0 auto" }} />  
         <h4> Page Not Found</h4>
         <p>  We Couldn't Find This Pages. </p>  
         <Link to="/" className="btn btn-primary button-notfound"> <i className="bi bi-arrow-left-short"></i>  Continue  </Link>
      </div>
     </>
  )
}
export default Notfound;